<template>
  <div>
    <div class="bgImg">
      <div class="title">家长端</div>
      <div v-if="qrcodeUrl" class="qrcode">
        <div>
          <img :src="qrcodeUrl" />
          <div>家长端小程序</div>
        </div>
      </div>
      <div v-else class="qrcode">
        <div>
          <img src="../../../public/gateway/parent/parentApp.png" />
          <div>家长端APP</div>
        </div>
        <div class="qrcode-mp">
          <img src="../../../public/gateway/parent/parentMP.jpg" />
          <div>家长端小程序</div>
        </div>
      </div>
      <img
        src="../../../public/gateway/parent/parent@2x.png"
        width="100%"
        class="parentPC"
      />
      <img
        src="../../../public/gateway/parent/parentMobile.png"
        width="100%"
        class="parentMobile"
      />
    </div>
  </div>
</template>

<script>
import gateway from '../../api/gateway'
export default {
  name: 'index',
  data() {
    return {
      qrcodeUrl: '',
    }
  },
  created() {
    this.getSchoolInfo()
  },
  methods: {
    getSchoolInfo() {
      gateway.getSchoolInitData().then((res) => {
        this.qrcodeUrl = res.data.qrcodeUrl
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

@media screen and (min-width: 510px) {
  .bgImg {
    width: 100%;
    // height: 100%;
    padding: 100px 0 0 240px;
    position: relative;
    // background: url('../../../public/gateway/parent/parent@2x.png') no-repeat;
    // background-size: 100% 100%;

    .title {
      font-size: 72px;
      color: #ffffff;
      font-weight: 600;
    }

    .qrcode {
      font-size: 24px;
      color: #ffffff;
      font-weight: 600;
      margin-top: 54px;
      display: flex;
      align-items: center;
      text-align: center;

      img {
        width: 260px;
        height: 260px;
        margin-bottom: 28px;
        border-radius: 10px;
      }

      .qrcode-mp {
        margin-left: 40px;
      }
    }
  }

  .parentPC {
    top: 0;
    left: 0;
    position: absolute;
  }

  .parentMobile {
    display: none;
  }
}

@media screen and (max-width: 510px) {
  .bgImg {
    width: 100%;
    background-color: #22cb76;
    padding-top: 40px;

    .title {
      font-size: 36px;
      color: #ffffff;
      font-weight: 600;
      text-align: center;
    }

    .qrcode {
      width: 100%;
      font-size: 24px;
      color: #ffffff;
      font-weight: 600;
      text-align: center;
      margin-top: 30px;

      img {
        width: 200px;
        height: 200px;
        margin-bottom: 20px;
        border-radius: 10px;
      }

      .qrcode-mp {
        margin-top: 40px;
      }
    }
  }
}
</style>
